<template>
  <vs-popup id="popupSignField" title="서명" :active.sync="showPopup">
    <div>
      <div v-if="!image && !readonly" class="flex justify-end gap-2 mb-2">
        <vs-button class="mr-auto" color="secondary" @click.prevent="handleClickLoadSign">내 서명 불러오기</vs-button>
        <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.undo()">실행취소</vs-button>
        <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.redo()">다시실행</vs-button>
        <vs-button color="secondary" @click.prevent="$refs.VueCanvasDrawing.reset()">초기화</vs-button>
      </div>
      <div v-if="image" style="text-align: center;">
        <div class="sign-img" :style="{backgroundImage: `url(${image})`}"></div>
        <!--        <img v-if="image" height="270" :src="image" style="display: inline-block; content: ''; border: 1px solid #cdcdcd;"/>-->
      </div>
      <vue-drawing-canvas
        v-else-if="this.showPopup"
        ref="VueCanvasDrawing"
        :image.sync="useImage"
        :width="570"
        :height="270"
        :lineWidth="8"
        stroke-type="dash"
        line-cap="round"
        line-join="round"
        :fill-shape="false"
        :eraser="false"
        color="#000000"
        background-color="transparent"
        saveAs="png"
        :styles="{ border: 'solid 1px #cdcdcd' }"
        :lock="readonly"
      />
      <div v-if="!readonly" class="flex justify-end gap-2">
        <vs-button v-if="image" @click="handleDelete">삭제</vs-button>
        <vs-button v-else @click="handleSave">적용</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import VueDrawingCanvas from "vue-drawing-canvas";

export default {
  name: 'PopupSignField',
  components: {
    VueDrawingCanvas,
  },
  props: {
    value: Boolean,
    image: String,
    selectId: [String, Number],
    readonly: Boolean,
  },
  watch: {
    value (data) {
      this.showPopup = data
    },
    showPopup (data) {
      this.$emit('input', data)
    },
  },
  data () {
    return {
      showPopup: false,

      useImage: '',
    }
  },


  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false
        next(false); return
      }
      next(true)
    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },

  created () {
    this.showPopup = this.value
    this.oldSelectCompanyId = this.selectId
  },

  methods: {

    async loadCompanyList () {
      const page = this.page.current
      const perPage = this.page.perPage
      const keyword = this.search.keyword
      const projectId = this.projectId
      await this.$store.dispatch('company/LOAD_COMPANY_LIST', {
        page,
        perPage,
        keyword,
        projectId
      })

    },

    loadSign (callback) {
      const options = {
        name: '',
      };
      this.$store.dispatch("member/LOAD_SIGNATURE", options).then((signList) => {
        let defualtSign = undefined;
        for (let i = 0; i < signList.length; i++) {
          if (signList[i].is_default) {
            defualtSign = signList[i];
            break;
          }
        }
        if (callback) {
          callback(defualtSign);
        }
      }).catch((error) => {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "에러",
            message: error,
          },
        });
        window.dispatchEvent(customAlert);
      });
    },

    handleClickLoadSign () {
      this.loadSign((data) => {
        if (data && data.file) {
          this.$emit("update", data.file.path);
        } else {
          this.$emit("update", false);
        }
      })
    },

    handleClickClose () {
      this.$emit('input', false)
      this.$emit('handleClickClose')
    },

    handleSave () {
      this.$emit("save", this.useImage)
      this.showPopup = false
    },

    handleDelete () {
      this.$emit("delete")
      this.showPopup = false
    }
  }
}

</script>


<style>

#popupSignField > .vs-popup {
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none
}

</style>

<style scoped>
.sign-img {
  width: 570px;
  height: 270px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  border: 1px solid #cdcdcd;
  margin-bottom: 10px;
}
</style>
